import { Link } from "react-router-dom";
import styled from "styled-components";
import PhoneInput from "react-phone-input-2";

export const TelInput = styled(PhoneInput)`
  width: 180px;
  input {
    color: #505050 !important;
    width: 100% !important;
  }
`;

export const Header = styled.div`
  width: 100%;
  /* height: 100%; */
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem; 
  border-bottom: 3px solid #f5fbff;
   @media (max-width: ${({ theme }) => theme.size.tabletL}) {
   flex-direction: column;
   }
   
`;

export const HeaderInfos = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: baseline;
`;

export const HeaderLocation = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color:${({ theme }) => theme.colors.primary};
`;

export const HeaderTitle = styled.h4`
  display: flex;
  justify-content: flex-start;
  font-size: 0.9rem;
  font-weight: 500;
  margin: 0;
  color: #809fb8;
`;

export const HeaderActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  flex: 1;

  @media ${({ theme }) => theme.device.laptop} {
    /* flex-direction: column; */
  }
`;

export const HeaderAction = styled.div`
  height: 50px;
  margin-left: 1rem;
`;

export const SearchInputContainer = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0.5rem 1rem;
  border: 1px solid ${({ theme }) => theme.colors.btnBorder};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.lightBlack};

 
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  color: ${({ theme }) => theme.colors.lightBlack};
  font-size: 0.8rem;

  &:focus {
    outline: none;
    color: ${({ theme }) => theme.colors.btnBorder} !important;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.lightBlack} !important;
    font-style: italic;
  }
  &:focus-within {
    // border: 2px solid #2174B9;
    color: ${({ theme }) => theme.colors.lightBlack};
  }
`;

export const BtnIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.5rem;
`;

export const SecondaryBtnOutlineActionModal = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1rem;
  height: 28px;
  padding: 0px 1px;
  border: 2px solid
    ${({ theme, border }) => (border ? border : theme.colors.danger)};
  border-radius: 6px;
  color: ${({ theme, color }) => (color ? color : theme.colors.danger)};
  cursor: pointer;
  font-size: 0.9rem;
  background-color: #ffffff;
  white-space: nowrap;

  & span {
    color: ${({ theme, color }) => (color ? color : theme.colors.primary)};
  }

  &:hover {
    background-color: ${({ theme, hov }) =>
        hov ? hov : theme.colors.btnHover};
  }
`;

export const PrimaryBtnOutlineActionModal = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  padding: 0px 1px;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 6px;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  font-size: 0.9rem;
  background-color: #ffffff;
  white-space: nowrap;

  & span {
    color: ${({ theme }) => theme.colors.primary};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.btnHover};
  }
`;

export const PrimaryBtnOutlineAction = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  margin-left: 1rem;
  padding: 0.5rem 1.2rem;
  border: 1px solid ${({ theme, border }) => (border ? border : theme.colors.content)};
  border-radius: 8px;
  color: ${({ theme, color }) => (color ? color : theme.colors.content)}; 
  cursor: pointer;
  font-size: 0.9rem;
  background-color:${({ theme, bg }) => (bg ? bg : theme.colors.content)};
  white-space: nowrap;

   @media (max-width: ${({ theme }) => theme.size.laptopL}) {
     margin-left: 0.2rem;
     padding: 0.3rem 0.5rem;
   }
    @media (max-width: ${({ theme }) => theme.size.mobileL}) {
        padding: 0.1rem 0.3rem;
   }
  & span {
    color: ${({ theme, color }) => (color ? color : theme.colors.content)};
    font-weight: 700;
    line-height: 1.4;
    font-size: 0.75rem;
    letter-spacing: -0.025rem;
    text-transform: uppercase;
     @media (max-width: ${({ theme }) => theme.size.laptopL}) {

          font-size: 0.75rem;
        width: fit-content; 
        white-space: nowrap;
        overflow: hidden; 
        text-overflow: ellipsis;
    }
  }

  &:hover {
       border: 2px solid ${({ theme,bd }) =>bd ? bd: theme.colors.primary};
         opacity: 0.99;
     }
     &:hover > span {
           color: ${({ theme }) => theme.colors.content} !important;  
     }
      &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const CancelBtnOutlineAction = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  margin-left: 1rem;
  padding: 0.5rem 1.4rem;
  border: 1px solid ${({ theme }) => theme.colors.content};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.content};
  cursor: pointer;
  background-color:${({ theme }) => theme.colors.danger};
  white-space: nowrap;
  font-weight: 700;
  line-height: 1.4;
  font-size: 0.75rem;
  letter-spacing: -0.025rem;
  text-transform: uppercase;
  & span {
    color: ${({ theme }) => theme.colors.content};
  }
  &:hover {        
       border: 2px solid ${({ theme }) => theme.colors.danger};     
     }
  &:hover > span {
   }
  @media (max-width: ${({ theme }) => theme.size.laptopL}) {
      padding: 0.3rem 0.5rem;
      font-size:0.75rem;
      margin-left: 0.175rem;
  }
   @media (max-width: ${({ theme }) => theme.size.mobileL}) {
        padding: 0.1rem 0.3rem;
   }
  
 
`;

export const SecondaryBtnOutlineAction = styled.button`
  display: flex;
  justify-content: center;
  white-space: nowrap;
  align-items: center;
  height: 40px;
  margin-left: 1rem;
  padding: 0.5rem 1rem;
 border: 1px solid ${({ theme, border }) => border ? border: theme.colors.btnBorder};
  //border: 2px solid ${({ theme }) => theme.colors.gray};
  border-radius: 8px;
  color: ${({ theme, color }) => (color ? color : theme.colors.lightBlack)};
  cursor: pointer;
  font-size: 0.9rem;
  background-color: ${({ theme, bg }) => (bg ? bg : "#ffffff")};

  & span {
    color: ${({ theme, color }) => (color ? color : theme.colors.lightBlack)};
  }

  &:hover {
     border: 2px solid ${({ theme, border }) => border ? border : theme.colors.btnBorder};
  }
   &:hover > span {
           color: ${({ theme }) => theme.colors.btnBorder} !important;  
     }
   &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const DensityBtnOutlineAction = styled.button`
  display: flex;
  justify-content: center;
  white-space: nowrap;
  align-items: center;
  border: none;
  height: 50px;
  margin-left: 1rem;
  padding: 0.5rem 1rem;
  color: ${({ theme }) => theme.colors.secondary};
  cursor: pointer;
  font-size: 0.9rem;
  background-color: #ffffff;

  & span {
    color: ${({ theme }) => theme.colors.secondary};
  }

     @media ${({ theme }) => theme.device.tabletL} {
        margin-left: 0rem;
        padding: 0.5rem 0.5rem;
    }
`;

export const FormGroup = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 0.15rem;
  border-bottom: 1px solid ${({ theme,bd }) =>bd ? bd: theme.colors.borderGray};

  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  &.fadeOut {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 300ms, opacity 300ms;
  }

  &.fadeIn {
    visibility: visible;
    opacity: 1;
    transition: visibility 0s linear 0s, opacity 300ms;
  }

  
`;

export const FormLabel = styled.label`
  // cursor: pointer;
  display: flex;
  margin: 0 0.5rem 0 0;
  padding: 0;
  white-space: nowrap;
  color: ${({ theme, color }) => (color ? color : theme.colors.secondary)};
`;

export const FormInput = styled.input`
  /* flex: 1; */
  border: none;
  outline: none;
  flex: 1;
  /* width: 170px; */
  text-align: right;
  color: #505050;
  font-size: 0.8rem;
  &::placeholder {
    color: ${({ theme }) => theme.colors.gray};
    font-style: italic;
  }
`;

export const FormInputTextarea = styled.textarea`
  /* flex: 1; */
  border: none;
  outline: none;
  flex: 1;
  /* width: 170px; */
  text-align: right;
  color: #505050;
  font-size: 0.8rem;
  resize: none;
  overflow: hidden;
  &::placeholder {
    color: ${({ theme }) => theme.colors.gray};
    font-style: italic;
  }
`;

export const FormSelect = styled.select`
  background: white;
  border: none;
  outline: none;
  flex: 1;
  text-align: right;
  color: #505050;
  text-overflow: ellipsis;
  width: 100%;
`;

export const FormECListContainerAccountRequest = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: auto;
  border: 1px solid #809fb866;
  border-radius: 18px;
  padding: 0.5rem;
  width: 80%;
  margin: 0.5rem 0;
  @media (max-width: 1000px) {
    /* flex-direction: column; */
    display: block;
  }
`;

export const BtnFilter = styled.div`
width: 40px;
border-radius: 8px;
background: #F96513;
display: flex;
justify-content: center;
margin-left: 2px;
padding: 1px;
 cursor: pointer;
`